export default __webpack_public_path__ + "static/media/homepage-players-app.56519ed3.png";